// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { AttributeId } from "./attribute-id";
import { NodeId, NodeIdT, verifyNodeId } from "./node-id";
import { QualifiedName, QualifiedNameT, verifyQualifiedName } from "./qualified-name";

/**
 * Selects a single event field (an attribute reached by a browse path from an
 * event type). Used in EventFilter select clauses.
 */
export class SimpleAttributeOperand implements flatbuffers.IUnpackableObject<SimpleAttributeOperandT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimpleAttributeOperand {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimpleAttributeOperand(
    bb: flatbuffers.ByteBuffer,
    obj?: SimpleAttributeOperand,
  ): SimpleAttributeOperand {
    return (obj || new SimpleAttributeOperand()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsSimpleAttributeOperand(
    bb: flatbuffers.ByteBuffer,
    obj?: SimpleAttributeOperand,
  ): SimpleAttributeOperand {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimpleAttributeOperand()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  /**
   * Event type the operand applies to (e.g. `BaseEventType`).
   */
  typeDefinitionId(obj?: NodeId): NodeId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NodeId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Browse path to the field within the event.
   */
  browsePath(index: number, obj?: QualifiedName): QualifiedName | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new QualifiedName()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  browsePathLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Attribute of the reached node (usually Value).
   */
  attributeId(): AttributeId {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : AttributeId.Value;
  }

  /**
   * Optional numeric/index range string.
   */
  indexRange(): string | null;
  indexRange(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  indexRange(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startSimpleAttributeOperand(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addTypeDefinitionId(
    builder: flatbuffers.Builder,
    typeDefinitionIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(0, typeDefinitionIdOffset, 0);
  }

  static addBrowsePath(builder: flatbuffers.Builder, browsePathOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, browsePathOffset, 0);
  }

  static createBrowsePathVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBrowsePathVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addAttributeId(builder: flatbuffers.Builder, attributeId: AttributeId) {
    builder.addFieldInt32(2, attributeId, AttributeId.Value);
  }

  static addIndexRange(builder: flatbuffers.Builder, indexRangeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, indexRangeOffset, 0);
  }

  static endSimpleAttributeOperand(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createSimpleAttributeOperand(
    builder: flatbuffers.Builder,
    typeDefinitionIdOffset: flatbuffers.Offset,
    browsePathOffset: flatbuffers.Offset,
    attributeId: AttributeId,
    indexRangeOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    SimpleAttributeOperand.startSimpleAttributeOperand(builder);
    SimpleAttributeOperand.addTypeDefinitionId(builder, typeDefinitionIdOffset);
    SimpleAttributeOperand.addBrowsePath(builder, browsePathOffset);
    SimpleAttributeOperand.addAttributeId(builder, attributeId);
    SimpleAttributeOperand.addIndexRange(builder, indexRangeOffset);
    return SimpleAttributeOperand.endSimpleAttributeOperand(builder);
  }

  unpack(): SimpleAttributeOperandT {
    return new SimpleAttributeOperandT(
      this.typeDefinitionId() !== null ? this.typeDefinitionId()!.unpack() : null,
      this.bb!.createObjList<QualifiedName, QualifiedNameT>(
        this.browsePath.bind(this),
        this.browsePathLength(),
      ),
      this.attributeId(),
      this.indexRange(),
    );
  }

  unpackTo(_o: SimpleAttributeOperandT): void {
    _o.typeDefinitionId =
      this.typeDefinitionId() !== null ? this.typeDefinitionId()!.unpack() : null;
    _o.browsePath = this.bb!.createObjList<QualifiedName, QualifiedNameT>(
      this.browsePath.bind(this),
      this.browsePathLength(),
    );
    _o.attributeId = this.attributeId();
    _o.indexRange = this.indexRange();
  }

  unpackFields(...fields: string[]): SimpleAttributeOperandT {
    const t = new SimpleAttributeOperandT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("type_definition_id")) {
      t.typeDefinitionId =
        this.typeDefinitionId() !== null ? this.typeDefinitionId()!.unpack() : null;
    }
    if (fieldSet.has("browse_path")) {
      t.browsePath = this.bb!.createObjList<QualifiedName, QualifiedNameT>(
        this.browsePath.bind(this),
        this.browsePathLength(),
      );
    }
    if (fieldSet.has("attribute_id")) {
      t.attributeId = this.attributeId();
    }
    if (fieldSet.has("index_range")) {
      t.indexRange = this.indexRange();
    }
    return t;
  }
}

export class SimpleAttributeOperandT implements flatbuffers.IGeneratedObject {
  constructor(
    public typeDefinitionId: NodeIdT | null = null,
    public browsePath: QualifiedNameT[] = [],
    public attributeId: AttributeId = AttributeId.Value,
    public indexRange: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const typeDefinitionId =
      this.typeDefinitionId !== null ? this.typeDefinitionId!.pack(builder) : 0;
    const browsePath = SimpleAttributeOperand.createBrowsePathVector(
      builder,
      builder.createObjectOffsetList(this.browsePath),
    );
    const indexRange = this.indexRange !== null ? builder.createString(this.indexRange!) : 0;

    return SimpleAttributeOperand.createSimpleAttributeOperand(
      builder,
      typeDefinitionId,
      browsePath,
      this.attributeId,
      indexRange,
    );
  }

  clone(): SimpleAttributeOperandT {
    const obj = new SimpleAttributeOperandT();
    obj.typeDefinitionId = this.typeDefinitionId !== null ? this.typeDefinitionId!.clone() : null;
    obj.browsePath = this.browsePath.map((e) => e.clone());
    obj.attributeId = this.attributeId;
    obj.indexRange = this.indexRange;
    return obj;
  }

  equals(other: SimpleAttributeOperandT): boolean {
    if (this.typeDefinitionId !== null && other.typeDefinitionId !== null) {
      if (!this.typeDefinitionId!.equals(other.typeDefinitionId!)) return false;
    } else if (this.typeDefinitionId !== other.typeDefinitionId) return false;
    if (this.browsePath.length !== other.browsePath.length) return false;
    for (let i = 0; i < this.browsePath.length; i++) {
      const a = this.browsePath[i];
      const b = other.browsePath[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.attributeId !== other.attributeId) return false;
    if (this.indexRange !== other.indexRange) return false;
    return true;
  }
}

export function verifySimpleAttributeOperand(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeId(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyQualifiedName);
      }
    }
    verifier.checkScalarField(tablePos, 8, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
